(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-video-animation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = () => {
      const components = document.querySelectorAll('[data-home-video-animation]');
      if (!components.length) return;

      function animateLayout(container, toggleFn, options = { duration: 0.3, easing: [0.22, 1, 0.36, 1] }) {
        const { animate } = window.Motion;
        const children = Array.from(container.children);

        const firstRects = children.map((child) => child.getBoundingClientRect());

        toggleFn();

        const animations = children.map((child, i) => {
          const firstRect = firstRects[i];
          const lastRect = child.getBoundingClientRect();

          const dx = firstRect.left - lastRect.left;
          const dy = firstRect.top - lastRect.top;

          if (!dx && !dy) return;

          return animate(
            child,
            {
              x: [dx, 0],
              y: [dy, 0],
            },
            options
          );
        });

        return Promise.all(animations.filter(Boolean));
      }

      const initializeComponent = (component) => {
        const isMobile = window.matchMedia('(max-width: 750px)').matches;
        const { scroll, inView, animate } = window.Motion;
        if (component.dataset.homeVideoAnimationInitialized === 'true') return;
        component.dataset.homeVideoAnimationInitialized = 'true';

        const track = component.querySelector('[data-home-video-track]');
        const stickySceneContainer = component.querySelector('[data-sticky-scene-container]');
        const mediaItems = component.querySelectorAll('[data-home-video-media-item]');
        if (!track || !mediaItems.length) return;

        const scene1Mask = component.querySelector('[data-scene-1-mask]');
        const track0 = component.querySelector('[data-scene-track="0"]');
        if (scene1Mask && track0 && !isMobile) {
          scroll(
            animate(
              scene1Mask,
              {
                opacity: [1, 0],
                transform: ['scale(1)', 'scale(4)'],
              },
              {
                delay: 0.1,
              }
            ),
            {
              target: track0,
              offset: ['start start', 'end center'],
            }
          );
        }

        const sceneTracks = component.querySelectorAll('[data-scene-track]');
        const sceneCount = 4;

        const updateScene = (sceneIndex) => {
          const isMobile = window.matchMedia('(max-width: 750px)').matches;
          const boundedSceneIndex = Math.max(0, Math.min(sceneCount - 1, sceneIndex));

          const activeMediaIndex = isMobile && boundedSceneIndex === 3 ? 2 : boundedSceneIndex;

          for (const mediaItem of mediaItems) {
            const itemIndex = Number.parseInt(mediaItem.dataset.sceneIndex || '-1', 10);
            const isActive = itemIndex === activeMediaIndex;
            const wasActive = mediaItem.classList.contains('is-active');

            mediaItem.classList.toggle('is-active', isActive);

            if (isActive) {
              if (!wasActive || boundedSceneIndex === itemIndex) {
                mediaItem.classList.remove('play-blink');
                void mediaItem.offsetWidth;
                mediaItem.classList.add('play-blink');

                const video = mediaItem.querySelector('[data-home-video]');
                const videoMobile = mediaItem.querySelector('[data-home-video-mobile]');

                if (video && !isMobile) {
                  video.currentTime = 0;
                  const playPromise = video.play();
                  if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                  }
                }
                if (isMobile && videoMobile) {
                  videoMobile.currentTime = 0;
                  const playPromise = videoMobile.play();
                  if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                  }
                }
              }
            } else {
              mediaItem.classList.remove('play-blink');
            }
          }

          if (!isMobile || boundedSceneIndex !== 3) {
            updateSceneText(boundedSceneIndex);
          }
        };

        sceneTracks.forEach((sceneTrack) => {
          const amount = +sceneTrack.dataset.amount || 0;
          const margin = sceneTrack.dataset.margin || '0px';
          const mobileAmount = +sceneTrack.dataset.mobileAmount || 0;
          const isMobileInit = window.matchMedia('(max-width: 750px)').matches;

          inView(
            sceneTrack,
            () => {
              const inViewSceneIndex = +sceneTrack.dataset.sceneTrack;
              updateScene(inViewSceneIndex);

              return () => {
                const isMobileNow = window.matchMedia('(max-width: 750px)').matches;

                if (isMobileNow && inViewSceneIndex === 2) {
                  return;
                }

                const item = mediaItems[inViewSceneIndex];
                if (!item) return;
                const animationTextList = item.querySelectorAll('[data-scene-animation-text]');
                animationTextList.forEach((textElement) => {
                  window.Motion.animate(
                    textElement,
                    {
                      opacity: [1, 0],
                      y: ['0%', '-10%'],
                    },
                    { duration: isMobileNow ? 0.05 : 0.2 }
                  );
                });
              };
            },
            { amount: isMobileInit ? mobileAmount : amount, margin }
          );
        });

        const updateSceneText = (activeSceneIndex) => {
          const { animate } = window.Motion;
          const mediaItem = mediaItems[activeSceneIndex];
          const isMobile = window.matchMedia('(max-width: 750px)').matches;

          const animationTextList = mediaItem.querySelectorAll('[data-scene-animation-text]');
          if (!animationTextList.length) return;

          animationTextList.forEach((textElement, index) => {
            textElement.style.opacity = '0';
            textElement.style.transform = 'translateY(100%)';
            let animationDelay = +textElement.dataset.animationDelay || 0;
            if (isMobile) {
              animationDelay = animationDelay * 0.5;
            }

            setTimeout(() => {
              animate(
                textElement,
                {
                  filter: ['blur(6px)', 'blur(0px)'],
                  opacity: [0, 1],
                  y: ['50%', '0%'],
                },
                {
                  duration: isMobile ? 0.7 : 1.25,
                  delay: animationDelay,
                  type: 'spring',
                  bounce: 0.25,
                }
              );
            }, 10);
          });
        };

        sceneTracks.forEach((sceneTrack) => {
          const amount = +sceneTrack.dataset.amount || 0;
          const margin = sceneTrack.dataset.margin || '0px';
          const mobileAmount = +sceneTrack.dataset.mobileAmount || 0;
          const isMobile = window.matchMedia('(max-width: 750px)').matches;
          inView(
            sceneTrack,
            () => {
              const inViewSceneIndex = +sceneTrack.dataset.sceneTrack;
              updateScene(inViewSceneIndex);

              return () => {
                const item = mediaItems[inViewSceneIndex];
                if (!item) return;
                const animationTextList = item.querySelectorAll('[data-scene-animation-text]');
                animationTextList.forEach((textElement) => {
                  animate(
                    textElement,
                    {
                      opacity: [1, 0],
                      y: ['0%', '-10%'],
                    },
                    { duration: isMobile ? 0.05 : 0.2 }
                  );
                });
              };
            },
            { amount: isMobile ? mobileAmount : amount, margin }
          );
        });

        // const mobileIconContainer = component.querySelector('.scene-text-container.sm\\:hidden');
        // if (mobileIconContainer && isMobile) {
        //   const observer = new IntersectionObserver(
        //     (entries) => {
        //       entries.forEach((entry) => {
        //         if (entry.isIntersecting) {
        //           entry.target.classList.add('play-blink');
        //           observer.unobserve(entry.target);
        //         }
        //       });
        //     },
        //     { threshold: 0.3 }
        //   );
        //   observer.observe(mobileIconContainer);
        // }

        const expandButtonList = component.querySelectorAll('.expand-button');

        expandButtonList.forEach((button) => {
          button.addEventListener('click', (event) => {
            const isExpanded = button.dataset.isExpanded === 'true';
            const interactiveCard = button.closest('.interactive-card');

            if (interactiveCard) {
              interactiveCard.classList.toggle('is-expanded', !isExpanded);
              const interactiveCardContent = interactiveCard.querySelector('.interactive-card-content');
              const interactiveCardContentText = interactiveCard.querySelector('.interactive-card-content-text');

              const interactiveCardImages = interactiveCard.querySelectorAll('.interactive-card-image');

              animateLayout(interactiveCardContent, () => {
                interactiveCardContent.classList.toggle('justify-center', !isExpanded);
                interactiveCardContentText.classList.toggle('opacity-0', isExpanded);

                interactiveCardImages.forEach((img) => {
                  img.classList.toggle('opacity-0', !isExpanded);
                });
              });
            }
            button.dataset.isExpanded = !isExpanded;
            button.querySelector('.plus-icon').classList.toggle('opacity-0', !isExpanded);
            button.querySelector('.close-icon').classList.toggle('opacity-0', isExpanded);
          });
        });
      };

      for (const component of components) {
        initializeComponent(component);
      }
    };

    document.addEventListener('DOMContentLoaded', mount, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
